import { Building2, Check, ChevronDown } from 'lucide-react'

import { Button } from '../../components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '../../components/ui/primitives'
import { cn } from '../../lib/utils'
import { useOrgScope } from '../scope'

/** Scope the console to one organisation.
 *
 * Named "scope", not "tenant": it narrows what the server returns, it does not
 * switch identity. See agent/scope.tsx for why that distinction matters here.
 */
export function OrgScopeSelect() {
  const { orgId, setOrgId, organizations, current, isLoading } = useOrgScope()

  if (isLoading || organizations.length === 0) return null

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="gap-1.5 px-2">
          <Building2 className="size-4 opacity-70" />
          <span className="hidden max-w-[9rem] truncate sm:inline">
            {current ? current.name : 'All organisations'}
          </span>
          <ChevronDown className="size-3 opacity-60" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-64">
        <DropdownMenuLabel>Scope</DropdownMenuLabel>
        <DropdownMenuItem onSelect={() => setOrgId(null)}>
          <Check className={cn('size-3.5', orgId !== null && 'invisible')} />
          All organisations
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        {organizations.map((org) => (
          <DropdownMenuItem key={org.id} onSelect={() => setOrgId(String(org.id))}>
            <Check className={cn('size-3.5', orgId !== String(org.id) && 'invisible')} />
            <span className="truncate">{org.name}</span>
          </DropdownMenuItem>
        ))}
        <DropdownMenuSeparator />
        <p className="px-2 py-1.5 text-xs text-muted-foreground">
          Filters what the server returns. It cannot widen your access.
        </p>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
